import { css } from '@emotion/react'
import { Text } from 'bold-ui'

type NewsListItemProps = {
  children: React.ReactNode
  fontSize?: number
}

export const NewsListItem = (props: Readonly<NewsListItemProps>) => {
  const { children, fontSize } = props
  return (
    <Text fontSize={fontSize} component='li' style={styles.listItem}>
      {children}
    </Text>
  )
}

const styles = {
  listItem: css`
    list-style-position: inside;
  `,
}
